<template>
    <div>
        <!-- Staff-authored free-form Today content (Roger's Trip App card).
             Full width, top billing, gone entirely when nothing is written. -->
        <div class="white-container mb-6" v-if="trip.app_today" v-html="trip.app_today"></div>

        <div class="columns">
        <div class="column is-two-thirds feed-column">
            <!-- Recent announcements outrank everything — staff post them when
                 something needs relaying or answering before departure. -->
            <today-announcements
                class="mb-6"
                :enabled="experienceEnabled"
                :posts="announcements"
                :latest-poll="latestPoll"
                :reg-id="registration.id"
                :is-staff="isStaff"
                @changed="$emit('changed')"
            />

            <div class="white-container pt-6 pb-6 has-text-centered">
                <h4 class="has-text-primary mb-5">Be There. Stay There. Play There.</h4>

                <flip-countdown :deadline="trip.start_on"></flip-countdown>
            </div>

            <!-- Mobile: tasks right under the countdown, before the trip blurb. -->
            <div class="is-hidden-desktop">
                <today-checklist
                    class="mt-5"
                    :trip="trip"
                    :registration="registration"
                    :user="user"
                    :has-payment-plan="hasPaymentPlan"
                />
                <hr class="mt-5 mb-5" style="border-bottom: 1px solid #ddd"/>
            </div>

            <ul class="sub-nav-menu mt-5 is-hidden-desktop" v-if="currentUser.registrations > 1">
                <router-link :to="{name: 'Trips'}">
                    <li><i class="far fa-tennis-ball fa-fw mr-3"></i>Choose a Different Trip</li>
                </router-link>
            </ul>
        </div>
        <div class="column is-one-third is-hidden-touch rail-column">
            <today-checklist
                :trip="trip"
                :registration="registration"
                :user="user"
                :has-payment-plan="hasPaymentPlan"
            />

            <ul class="sub-nav-menu mt-5" v-if="currentUser.registrations > 1">
                <router-link :to="{name: 'Trips'}">
                    <li><i class="far fa-tennis-ball fa-fw mr-3"></i>Choose a Different Trip</li>
                </router-link>
            </ul>
        </div>
        </div>
    </div>
</template>

<script>
    import FlipCountdown from 'vue2-flip-countdown';
    import {mapGetters} from 'vuex';
    import TodayChecklist from './TodayChecklist.vue';
    import TodayAnnouncements from './TodayAnnouncements.vue';

    export default {
        name: 'TodayPreTrip',
        components: {FlipCountdown, TodayChecklist, TodayAnnouncements},
        props: {
            trip: {type: Object, required: true},
            registration: {type: Object, required: true},
            user: {type: Object, required: true},
            hasPaymentPlan: {type: Boolean, default: false},
            announcements: {type: Array, required: true},
            latestPoll: {type: Object, default: null},
            experienceEnabled: {type: Boolean, default: false},
            isStaff: {type: Boolean, default: false}
        },
        computed: {
            ...mapGetters(['currentUser'])
        }
    };
</script>

<style lang="scss" scoped>
    // Same breathing room between the main column and the rail as Experience.
    @media screen and (min-width: 1024px) {
        .feed-column {
            padding-right: 2rem;
        }

        .rail-column {
            padding-left: 1rem;
        }
    }
</style>
